import React, { createContext, useContext, useState } from 'react';

export const availableProducts = [
    {
        id: 1,
        title: "Fun Card Year Subscription",
        price: 30,
        image: "assets/images/thumbs/banner-example.png",
        reviews: 128,
        rating: 4.8,
        tags: ["Full Coupon Access"]
    }
];

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([availableProducts[0]]);

    const addToCart = (product) => {
        setCartItems(prev => {
            if (prev.find(item => item.id === product.id)) return prev;
            return [...prev, product];
        });
    };

    const removeFromCart = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    return (
        <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, cartCount: cartItems.length }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
